import { useEffect, useSyncExternalStore } from 'react';
import { PusherService } from '../services/pusher-service';
import { subscribedChannelsStore } from '../store/pusher/subscribed-channels-store';

export const useIsPusherReady = () => {
  const channels = useSyncExternalStore(subscribedChannelsStore.subscribe, subscribedChannelsStore.getSnapShot);
  const isSubscribedToMainSellerChannel = !!channels.find((channel) => channel.channelName === PusherService.mainSellerChannelName);

  return {
    isSubscribedToMainSellerChannel,
  };
};

export const usePusherEvent = (eventName, eventHandler) => {
  const { isSubscribedToMainSellerChannel } = useIsPusherReady();
  useEffect(() => {
    if (isSubscribedToMainSellerChannel) {
      const unbindFromEventOnAllChannels = PusherService.bindToEventOnAllChannels(eventName, eventHandler);
      return () => unbindFromEventOnAllChannels();
    }
  }, [eventName, eventHandler, isSubscribedToMainSellerChannel]);
};
